import { useLocation, Link } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4 pt-20">
      <h1 className="text-8xl md:text-9xl font-black text-background-200 select-none mb-4">
        404
      </h1>
      <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-3">
        页面未找到
      </h2>
      <p className="text-base text-foreground-500 mb-2">
        抱歉，您访问的页面不存在或已被移除
      </p>
      <p className="text-sm text-foreground-400 font-mono mb-8">
        {location.pathname}
      </p>
      <Link
        to="/"
        className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-bold hover:bg-primary-600 transition-colors"
      >
        <i className="ri-home-line w-4 h-4 flex items-center justify-center" />
        返回首页
      </Link>
    </div>
  );
}